import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  CalendarInput,
  CalendarOutput,
  CalendarPriceInput,
  CalendarPriceOutput,
  CalendarSummaryPriceInput,
  City,
  ContractCityCacheCalendar,
} from '@pulpo/pulpo-models';
import ApiService from '../api.service.abstract';
import { APP_CONFIG } from '@pulpo/app-config';

@Injectable({ providedIn: 'root' })
export class CalendarEngineService extends ApiService<any> {
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient
  ) {
    super(environment, http, 'api/engine/calendar');
  }

  buildCalendar(
    calendarInput: CalendarInput
  ): Observable<HttpResponse<CalendarOutput>> {
    return this.http.post<any>(
      `${this.url}/${this.endpoint}/build`,
      { ...calendarInput },
      { observe: 'response' }
    );
  }

  getPricesForMonth(
    calendarPriceInput: CalendarPriceInput
  ): Observable<HttpResponse<CalendarPriceOutput>> {
    return this.http.post<any>(
      `${this.url}/${this.endpoint}/price`,
      { ...calendarPriceInput },
      { observe: 'response' }
    );
  }

  getStartCitiesFromContract(
    contractId: number
  ): Observable<HttpResponse<City[]>> {
    return this.http.get<City[]>(
      `${this.url}/${this.endpoint}/price/city?contractId=${contractId}`,
      { observe: 'response' }
    );
  }

  getCalendarSummary(
    calendarSummaryPriceInput: CalendarSummaryPriceInput
  ): Observable<HttpResponse<ContractCityCacheCalendar>> {
    return this.http.get<ContractCityCacheCalendar>(
      `${this.url}/${this.endpoint}/price/summary?contractId=${calendarSummaryPriceInput.contractId}&commissionProfileId=${calendarSummaryPriceInput.commissionProfileId}&startCityId=${calendarSummaryPriceInput.startCityId}&year=${calendarSummaryPriceInput.year}&language=${calendarSummaryPriceInput.language}`,
      { observe: 'response' }
    );
  }
}
